export function changeExpander() {
  let expander = document.getElementById('scp-consultant');
  let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    
  if (vw > 768) {
    expander.setAttribute('expanded', true);
  } else {
    expander.removeAttribute('expanded');
  }
}
